import React, { useEffect, useState } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { findDocumentByField } from '../../library/index';

const PrivateRoute: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/', { replace: true, state: { showSnackbar: true } });
      } else {
        let arrData: any[] = await findDocumentByField('users', 'email', user.email);
        if (arrData.length > 0) {
          navigate('/home');
        } else {
          navigate('/', { replace: true, state: { showSnackbar: true } });
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return <>
    <Outlet />
  </>;
};

export default PrivateRoute;
